export default {
    componentTemplateList: [],
    loading: false,
}
